export class BaseAction {
  type: string;
  constructor() {
    this.type = "BASE_ACTION_PLEASE_SET_YOUR_TYPE";
  }
}